export default __webpack_public_path__ + "static/media/include_3@2x.12cde65d.jpg";